export class FilterModel {
  constructor(payload) {
    this._from = payload.from;
    this._to = payload.to;
    this._betType = payload.betType;
    this._league = payload.league;
    this._betSelection = payload.betSelection;

    this._offset = 0;
    this._limit = 10;
  }

  get from() {
    return this._from;
  }

  get to() {
    return this._to;
  }

  get betType() {
    return this._betType;
  }

  get betSelection() {
    return this._betSelection;
  }

  get league() {
    return this._league;
  }

  set offset(offset) {
    this._offset = offset;
  }

  get offset() {
    return this._offset;
  }

  get limit() {
    return this._limit;
  }

  toPayload() {
    return {
      offset: this.offset,
      limit: this.limit,
      from: this.from,
      to: this.to,
      league: this.league,
      betType: this.betType,
      bet: this.betSelection,
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/component/bets/model/filter.model.js